import { loadGsap } from './gsap-loader.js';

/**
 * The empty-bag scene. The text rises in one line at a time, and the empty frame drops in, swings, and
 * then hangs with a slow drift. Everything is visible without GSAP or with reduced motion.
 */
class CartEmptyComponent extends HTMLElement {
  #reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /** @type {any} */
  #gsap = null;
  #timeline = null;

  connectedCallback() {
    if (this.#reduceMotion) return;
    loadGsap().then((gsap) => {
      if (!gsap || !this.isConnected) return;
      this.#gsap = gsap;
      this.#play();
    });
  }

  disconnectedCallback() {
    this.#timeline?.kill();
    this.#gsap?.killTweensOf(this.querySelectorAll('*'));
  }

  #play() {
    const gsap = this.#gsap;
    const frame = this.querySelector('[data-frame]');
    const shadow = this.querySelector('[data-shadow]');
    const lines = this.querySelectorAll('[data-reveal]');

    // Take over the starting state inline, so nothing flashes before the animation begins.
    gsap.set(lines, { opacity: 0, y: 28 });
    gsap.set(frame, { opacity: 0, y: -140, rotate: -7 });
    gsap.set(shadow, { opacity: 0 });

    this.#timeline = gsap
      .timeline({ defaults: { ease: 'expo.out' } })
      .to(lines, { opacity: 1, y: 0, duration: 0.9, stagger: 0.09, clearProps: 'opacity,transform' }, 0)
      .to(frame, { opacity: 1, y: 0, duration: 1.1, ease: 'bounce.out' }, 0.25)
      // Settles with a swing from its top edge, each swing smaller than the last.
      .to(frame, { rotate: 0, duration: 1.6, ease: 'elastic.out(1, 0.35)' }, 0.55)
      .to(shadow, { opacity: 1, duration: 0.8 }, 0.9)
      .add(() => {
        gsap.to(frame, { rotate: 0.8, y: -4, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
        gsap.to(shadow, { scaleX: 0.92, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
      });
  }
}

if (!customElements.get('cart-empty-component')) {
  customElements.define('cart-empty-component', CartEmptyComponent);
}
